export default function ExternalLink(props) {
    // eslint-disable-next-line
    return <a {...props} target="_blank" />;
}
